<template>
  <div class="container">
    <div @click="playSong()" v-if="playbutton" class="playing">
      <img src="../assets/play.png" alt="" class="play">
      <h4 >Play Song</h4></div>
    <div @click="pauseSong()" v-if="pausebutton" class="pausing">
      <img src="../assets/pausa.png" alt="" class="pause">
      <h4 >Pause</h4></div>    
  </div>
</template>
<script>

export default {
  name: "Music",
  components: {},
  data() {
    return {
      song: require("../assets/x_men.mp3"),
      playbutton: true,
      pausebutton: false,
      music:""
    };
  },
  created() {
    // this.playSong()
  },
  mounted() {},
  methods: {
   playSong() {
    console.log("Play song")
    this.music = new Audio(this.song)

    this.music.play();
    this.playbutton = false
    this.pausebutton = true
   },
   pauseSong() {
    console.log("Pause")
    this.music.pause();
    this.playbutton = true
    this.pausebutton = false
   }
    
  },
};
</script>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-self: flex-start;
  color: #fff;
	margin-top: 10%;
	text-shadow:
		0 0 5px rgba(0,178,255,1),
		0 0 10px rgba(0,178,255,1),
		0 0 20px rgba(0,178,255,1),
		0 0 40px rgba(38,104,127,1),
		0 0 80px rgba(38,104,127,1),
		0 0 90px rgba(38,104,127,1),
		0 0 100px rgba(38,104,127,1),
		0 0 140px rgba(38,104,127,1),
		0 0 180px rgba(38,104,127,1);
}
.play{
  width: 20px;
  height: 20px
}
.pause{
  width: 20px;
  height: 20px
}
</style>